// Playback policy for lottie_animation_controller.

// A slow load swaps to the static fallback only when one exists; otherwise keep waiting for the animation.
export function loadTimeoutAction({ loaded, hasFallback }) {
  if (loaded) return "none"
  return hasFallback ? "fallback" : "wait"
}

// maxLoops 0 = loop forever.
export function loopBudgetSpent(loopCount, maxLoops) {
  return maxLoops > 0 && loopCount >= maxLoops
}
